import { Tabs } from "@chakra-ui/react";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import ClaimedTab from "./ClaimedTab";
import ToClaimTab from "./ToClaimTab";
import { ToClaimItem } from "./types";
import { useFetchClaimsSummary } from "./useFetchClaimsSummary";

const ClaimsTab = (): JSX.Element => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get("claimsTab") ?? "porReclamar";
  const setActiveTab = (value: string) =>
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.set("claimsTab", value);
        return next;
      },
      { replace: true }
    );
  // Lives here so the list survives switching sub-tabs.
  const [items, setItems] = useState<ToClaimItem[]>([]);
  const { summary } = useFetchClaimsSummary();

  return (
    <Tabs.Root
      value={activeTab}
      onValueChange={(e) => setActiveTab(e.value)}
      variant="line"
      size="sm"
      colorPalette="palomma"
      display="flex"
      flexDirection="column"
      flex="1"
      minH={0}
    >
      <Tabs.List bg="transparent" mb={4} flexShrink={0}>
        <Tabs.Trigger value="porReclamar" fontWeight="medium" pb={2}>
          Por reclamar ({items.length})
        </Tabs.Trigger>
        <Tabs.Trigger value="reclamados" fontWeight="medium" pb={2}>
          Reclamados{summary && ` (${summary.count})`}
        </Tabs.Trigger>
      </Tabs.List>
      <Tabs.Content
        value="porReclamar"
        display="flex"
        flexDirection="column"
        flex="1"
        minH={0}
        css={{ "&[hidden]": { display: "none" } }}
      >
        <ToClaimTab
          items={items}
          setItems={setItems}
          onClaimed={() => setActiveTab("reclamados")}
        />
      </Tabs.Content>
      <Tabs.Content
        value="reclamados"
        display="flex"
        flexDirection="column"
        flex="1"
        minH={0}
        css={{ "&[hidden]": { display: "none" } }}
      >
        <ClaimedTab />
      </Tabs.Content>
    </Tabs.Root>
  );
};

export default ClaimsTab;
